import PersonOutlineIcon from '@mui/icons-material/PersonOutline'
import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import styled from '@mui/system/styled'

import { useImpersonation } from '@/contexts/impersonation/impersonation-context'

const ImpersonationBannerContainer = styled(Box)(({ theme }) => ({
	position: 'fixed',
	top: 0,
	left: 0,
	right: 0,
	zIndex: 1100,
	height: 'var(--ImpersonationBanner-height, 48px)',
}))

const ImpersonationAlert = styled(Alert)({
	borderRadius: 0,
	height: '100%',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
})

export function ImpersonationBanner() {
	const { isImpersonating, impersonatedUser } = useImpersonation()

	if (!isImpersonating) {
		return null
	}

	return (
		<ImpersonationBannerContainer>
			<ImpersonationAlert severity="info" icon={<PersonOutlineIcon />}>
				Impersonating user: <strong>{impersonatedUser}</strong>
			</ImpersonationAlert>
		</ImpersonationBannerContainer>
	)
}
